export enum EddRequestStatus {
  PENDING = "PENDING",
  SUBMITTED = "SUBMITTED",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export enum EddRequestType {
  EXPLAIN_TRANSACTION = "EXPLAIN_TRANSACTION",
  UPDATE_DOCUMENTS = "UPDATE_DOCUMENTS",
  VERIFY_SOURCE_OF_FUNDS = "VERIFY_SOURCE_OF_FUNDS",
}

export interface EddRequestModel {
  id: string;
  code: string;
  caseId: string;
  requestType: EddRequestType;
  reason: string;
  status: EddRequestStatus;
  rejectReason: string;
  deadline: string;
  createdAt: string;
}

export interface EddRequestDetailModel {
  id: string;
  code: string;
  requestType: EddRequestType;
  reason: string;
  status: EddRequestStatus;
  rejectReason: string;
  deadline: string;
  createdAt: string;
  explanationId: string;
  detailExplanation: string;
  documentUrls: Array<string>;
}
